import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import keymaster from 'keymaster';
import moment from 'moment';
import time from '../utils/time';
import { modalDidMount, modalWillUnmount } from './ModalFixMixin';

import AutoTaskInput from './AutoTaskInput';
import DurationFormatter from '../utils/duration';
import SimpleHashtagEditor from './SimpleHashtagEditor';

import floatingTaskActions from '../actions/floatingTaskActionCreators';
import * as logEntryActions from '../actions/logEntryActionCreators';

require.ensure([], () => {
    require('./EditModal.less');
});

const className = "EditModal";

class EditModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        let positionLeft = this.props.positionLeft;
        let placement = "right";
        let hm = time.parseDuration(this.props.logEntry.duration + "min");

        let startTime = this.props.logEntry.startTime;

        if (startTime && startTime.length === 12 && startTime.charAt(2) === ':' && startTime.charAt(5) === ':' && startTime.charAt(8) === '.') {
            startTime = startTime.substring(0, 5);
        }

        if (startTime && startTime.length === 8 && startTime.charAt(2) === ':' && startTime.charAt(5) === ':') {
            startTime = startTime.substring(0, 5);
        }

        let logEntries = JSON.parse(JSON.stringify(this.props.logEntries));
        for (let i = 0; i < logEntries.length; i++) {
            if (logEntries[i].id === this.props.logEntry.id) {
                logEntries.splice(i, 1);
                break;
            }
        }

        this.taskInput = {};

        this.state = {
            errors: [],
            cumulativeMap: this._buildCumulativeObject(logEntries),
            initialDuration: this.props.logEntry.duration,
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : "",
            startTime: startTime,
            description: this.props.logEntry.description,
            overtime: this.props.logEntry.overtime,
            lastModifiedByUser: this.props.logEntry.lastModifiedByUser,
            lastModifiedAt: this.props.logEntry.lastModifiedAt,
            editForUser: this.props.editForUser,
            date: this.props.logEntry.date ? moment(this.props.logEntry.date, "YYYY-MM-DD"): null,
            color: this.props.logEntry.color,
            positionLeft: positionLeft,
            positionTop: (this.props.positionTop < 0) ? 0 : this.props.positionTop,
            placement: placement,
            parent: this.props.parent,
            smartPopoverPlacement: this.props.smartPopoverPlacement,
            elementFocused: true,
            deleteFocused: false,
            closeFocused: false,
            projectName: this.props.logEntry.projectName,
            taskName: this.props.logEntry.taskName,
            editTask: false,
            tasks: this.props.tasks
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        modalDidMount();
        ReactDOM.findDOMNode(this.refs.durationInput).focus();

        //TODO - causes errors
        //this.setState({
        //    selfWidth: ReactDOM.findDOMNode(this.refs.taskInput.refs.taskField).offsetWidth
        //});

        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    componentWillReceiveProps = (nextProps) => {
        let positionLeft = nextProps.positionLeft;
        let placement = "right";

        if (this.state.smartPopoverPlacement && window.innerWidth > 640) {
            if (positionLeft + 300 > window.innerWidth) {
                placement = "left";
                positionLeft -= this.state.selfWidth + ReactDOM.findDOMNode(nextProps.parent).offsetWidth;

                // what happens is that on the first showing of the popover we get a parent offsetWidth
                // but on the second render we mysteriously always get 45 pixels larger parent offsetWidth
                // so on the first call, when this state.positionLeft has not been set yet, we do the math
                // but on each other call we subtract additional 45 pixels
                // this hardcoded version works best but lets try to solve it programatically
                //if (this.state.selfWidth === 300) {
                //    positionLeft -= 45;
                //}
                if (this.state.positionLeft) {
                    positionLeft -= 45;
                }
            }
        }

        let hm = time.parseDuration(nextProps.logEntry.duration + "min");

        let startTime = nextProps.logEntry.startTime;

        if (startTime && startTime.length === 12 && startTime.charAt(2) === ':' && startTime.charAt(5) === ':' && startTime.charAt(8) === '.') {
            startTime = startTime.substring(0, 5);
        }

        if (startTime && startTime.length === 8 && startTime.charAt(2) === ':' && startTime.charAt(5) === ':') {
            startTime = startTime.substring(0, 5);
        }

        let logEntries = JSON.parse(JSON.stringify(nextProps.logEntries));
        for (let i = 0; i < logEntries.length; i++) {
            if (logEntries[i].id === nextProps.logEntry.id) {
                logEntries.splice(i, 1);
                break;
            }
        }

        this.setState({
            errors: [],
            cumulativeMap: this._buildCumulativeObject(logEntries),
            initialDuration: nextProps.logEntry.duration,
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : "",
            startTime: startTime,
            description: nextProps.logEntry.description,
            overtime: nextProps.logEntry.overtime,
            lastModifiedByUser: nextProps.logEntry.lastModifiedByUser,
            lastModifiedAt: nextProps.logEntry.lastModifiedAt,
            editForUser: nextProps.editForUser,
            date: nextProps.logEntry.date ? moment(nextProps.logEntry.date, "YYYY-MM-DD"): null,
            positionLeft: positionLeft,
            positionTop: (nextProps.positionTop < 0) ? 0 : nextProps.positionTop,
            placement: placement,
            parent: nextProps.parent,
            smartPopoverPlacement: nextProps.smartPopoverPlacement,
            projectName: nextProps.logEntry.projectName,
            taskName: nextProps.logEntry.taskName,
            tasks: nextProps.tasks
        });
    }

    componentWillUnmount = () => {
        modalWillUnmount();
        if (this.props.returnKeymaster) {
            this.props.returnKeymaster();
        }
    }

    // EVENT HANDLERS

    handleCancel = () => { this.props.close(); }

    handleChange = (changeEvent) => {
        this.setState({
            overtime: !this.state.overtime
        }, time.checkForm.bind(this, className));
    }

    handleCloseFocus = () => { this.setState({ closeFocused: true }); }

    handleCumulativeToggle = () => { this.setState({ showCumulative: !this.state.showCumulative }); }

    handleDelete = () => {
        this.props.close();

        if (this.props.timesheet && !this.props.logEntry.overtime) {
            this.props.timesheet.timeSpent -= this.state.initialDuration;
        }
        this.props.dispatch(logEntryActions.deleteEntry(this.props.logEntry.id));

        if (!this.props.logEntry.projectName) {
            setTimeout(() => {this.props.dispatch(floatingTaskActions.isDeletable(this.props.logEntry.taskID));}, 250);
        }
    }

    handleDeleteBlur = () => { this.setState({ deleteFocused: false }); }

    handleDeleteFocus = () => { this.setState({ deleteFocused: true }); }

    handleDescriptionChange = (description) => {
        this.setState({
            description: description
        });
    }

    handleDurationChange = (event) => { this.setState({ durationString: event.target.value }); }

    handleEditTaskButton = () => {
        this.setState({
            editTask: !this.state.editTask
        }, () => {
            if (this.state.editTask) {
                if (this.refs.taskInput.refs.taskField)
                    ReactDOM.findDOMNode(this.refs.taskInput.refs.taskField).focus();
            }
        });
    }

    handleElementBlur = () => {
        this.setState({ elementFocused: false });
    }

    handleElementFocus = () => {
        this.setState({ elementFocused: true });
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter" && !this.state.deleteFocused && !this.state.closeFocused && !this.state.editTask && !keyEvent.shiftKey) {
            if (!this.props.timesheet || this.props.timesheet && this.props.timesheet.status === "ENTRY") {
                keyEvent.preventDefault();
                ReactDOM.findDOMNode(this.refs.durationInput).blur();
                setTimeout(this.handleSave, 50);
            }
        }

        if (!this.state.editTask) {
            keyEvent.stopPropagation();
        }
    }

    handleKeyUp = (keyEvent) => {
        if (!this.state.elementFocused && keyEvent.key === "Delete") {
            if (!this.props.timesheet || this.props.timesheet && this.props.timesheet.status === "ENTRY") {
                this.handleDelete();
            }
        }
        if (keyEvent.key === "Escape") {
            this.handleCancel();
        }

        keyEvent.stopPropagation();
    }

    handleRefocus = () => {
        ReactDOM.findDOMNode(this.refs.durationInput).focus();
        this.setState({
            closeFocused: false
        });
        this.handleElementFocus();
    }

    handleSave = () => {
        let logEntry = {};

        // TODO: sanitize input
        logEntry.date = this.state.date.format("YYYY-MM-DD");
        let duration = this.state.duration;
        let startTime = this.state.startTime;
        let description = this.state.description;
        let overtime = this.state.overtime;

        let errors = [];

        if (isNaN(duration))
            duration = 0;

        if (duration > 1440) {
            errors.push({ input: "duration", message: "Duration cannot exceed 24 hours" });
        }

        if (duration < 0) {
            errors.push({ input: "duration", message: "Duration cannot be negative" });
        }

        if (startTime && startTime.length > 0)
        {
            let startTimeValidation = new RegExp(/^([0-9]?|1[0-9]|2[0-3]|0[0-9]):[0-5][0-9]$/);

            if (!startTimeValidation.test(startTime)) {
                errors.push({ input: "startTime", message: "Start time must be in HH:mm format" });
            }
        }

        if (errors.length > 0) {
            this.setState({ errors: errors });

            return;
        }

        logEntry.duration = duration;
        logEntry.startTime = startTime;
        logEntry.description = description;
        logEntry.overtime = overtime;
        logEntry.lastModifiedByUser = "user unknown (user)";
        logEntry.lastModifiedAt = moment().format("YYYY-MM-DD[T]H:mm:ss");

        // format start time as HH:mm or HH:mm:ss
        if (logEntry.startTime && logEntry.startTime.charAt(1) === ":") {
            logEntry.startTime = "0" + logEntry.startTime;
        }

        if (this.state.editForUser) {
            logEntry.userID = this.state.editForUser.id;
        }

        if (this.props.currentUser) {
            logEntry.lastModifiedByUser = this.props.currentUser.givenName + " " + this.props.currentUser.surname + " (" + this.props.currentUser.username + ")";
        }

        logEntry.taskID = this.props.logEntry.taskID;

        logEntry = Object.assign({}, this.props.logEntry, logEntry);

        if (this.state.taskChanged) {
            logEntry.color = this.state.color;
            logEntry.taskName = this.props.selectedTask.name;
            logEntry.projectName = this.props.selectedTask.projectName;
            logEntry.task = {};
            logEntry.task.id = this.props.selectedTask.id;

            this.props.dispatch(logEntryActions.updateWithTask(logEntry));
        } else {
            this.props.dispatch(logEntryActions.update(logEntry));
        }
        this.props.close();
    }

    handleSliderChange = (event) => {
        let hm = time.parseDuration(event.target.value.trim() + "min");

        this.setState({
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : ""
        });
    }

    handleStartTimeChange = (event) => {
        this.setState({
            startTime: event.target.value
        }, time.checkForm.bind(this, className));
    }

    handleTaskChange = () => {
        //TODO not working without timeout
        setTimeout(() => {
            this.setState({
                color: this.props.selectedTask.color,
                taskChanged: true,
                editTask: false
            });
        }, 1);
    }

    // OTHER METHODS

    _convertToStandardForm = (event) => {
        let hm = time.parseDuration(event.target.value.trim());

        this.setState({
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : "",
            elementFocused: false
        });
    }

    _convertStartTime = (event) => {
        let hm = time.parseStartTime(event.target.value.trim());

        this.setState({
            startTime: hm !== null ? time.startTimeFormat(hm[0], hm[1]) : ""
        }, this.checkForm);
    }

    _buildCumulativeObject = (logEntries) => {
        let cumulativeMap = [];

        for (let i = 0; i < logEntries.length; i++) {
            let projectName = logEntries[i].projectName ? logEntries[i].projectName : "Floating tasks";
            let taskName = logEntries[i].taskName;

            if (!cumulativeMap[projectName]) {
                cumulativeMap[projectName] = {
                    tasks: [],
                    regularTimeLogged: 0,
                    overtimeLogged: 0
                };
            }

            if (!cumulativeMap[projectName].tasks[taskName]) {
                cumulativeMap[projectName].tasks[taskName] = {
                    regularTimeLogged: 0,
                    overtimeLogged: 0
                };
            }

            if (!logEntries[i].overtime) {
                cumulativeMap[projectName].regularTimeLogged += logEntries[i].duration;
                cumulativeMap[projectName].tasks[taskName].regularTimeLogged += logEntries[i].duration;
            } else {
                cumulativeMap[projectName].overtimeLogged += logEntries[i].duration;
                cumulativeMap[projectName].tasks[taskName].overtimeLogged += logEntries[i].duration;
            }
        }

        return cumulativeMap;
    }

    _fieldHasError = (fieldName) => {
        if (!this.state.errors) return false;

        for (let i = 0; i < this.state.errors.length; i++)
            if (this.state.errors[i].input === fieldName)
                return true;

        return false;
    }

    getInputBsStyle = (input) => {
        for (let i = this.state.errors.length - 1; i >= 0; --i)
            if (this.state.errors[i].input === input)
                return "error";

        return null;
    }

    getRefDOMNode = (refName) => {
        return ReactDOM.findDOMNode(this.refs[refName]).children[0];
    }

    isFocused = () => { return this.state.isFocused; }

    // RENDER METHOD

    render = () => {
        let backgroundColor = "#777777";
        if (this.props.logEntry && this.props.selectedTask.projectName) {
            backgroundColor = this.state.color;
        }

        // format lastModifiedAt nicely

        let lastModifiedAt = "unknown";

        if (this.state.lastModifiedAt) {
            let lastModifiedAtTokens = this.state.lastModifiedAt.split("T");
            lastModifiedAt = lastModifiedAtTokens[1].substring(0, 8) + " on " + lastModifiedAtTokens[0];
        }

        let calendarClass = moment().format("DD-MM-YYYY") === this.state.date.format("DD-MM-YYYY") ? "label-day today" : "label-day";

        let editable = !this.props.logEntry.projectArchived && ( this.props.logEntry.status === "DRAFT" || this.props.logEntry.status === "REJECTED" )
        && this.props.timesheet.status !== "SUBMITTED" && moment().subtract(31, 'days').isBefore(moment(this.props.logEntry.date), "DD-MM-YYYY");

        let projectName = this.props.logEntry.projectName ? this.props.logEntry.projectName : "Floating tasks";
        let loggedOnProject = this.state.cumulativeMap[projectName] ? JSON.parse(JSON.stringify(this.state.cumulativeMap[projectName])) : {regularTimeLogged: 0, overtimeLogged: 0};
        let loggedOnTask = this.state.cumulativeMap[projectName] && this.state.cumulativeMap[projectName].tasks[this.props.logEntry.taskName] ? JSON.parse(JSON.stringify(this.state.cumulativeMap[projectName].tasks[this.props.logEntry.taskName])) : {regularTimeLogged: 0, overtimeLogged: 0};

        if (this.state.overtime) {
            loggedOnProject.overtimeLogged += this.state.duration;
            loggedOnTask.overtimeLogged += this.state.duration;
        } else {
            loggedOnProject.regularTimeLogged += this.state.duration;
            loggedOnTask.regularTimeLogged += this.state.duration;
        }

        return (
            <Modal show={true} onKeyUp={this.handleKeyUp} onKeyPressCapture={this.handleKeyPress} className="edit-modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog new-log-entry">
                    <div className="modal-content">
                        <div className="head" style={{backgroundColor : backgroundColor, wordWrap: "break-word"}}>
                            <h4>
                                {this.props.selectedTask.projectName ? this.props.selectedTask.projectName : "FLOATING TASK"} &nbsp;&nbsp;
                                <span style={{cursor : "pointer"}} className="md-info" onClick={this.handleCumulativeToggle}/>
                            </h4>
                            <h5>
                                {this.props.selectedTask.name} &nbsp;&nbsp;
                                {
                                    !this.props.logEntry.projectArchived && (this.props.logEntry.status === "DRAFT" || this.props.logEntry.status === "REJECTED") ?
                                    <span style={{"cursor" : "pointer"}} onClick={this.handleEditTaskButton} className="md-mode-edit"/>
                                    : null
                                }
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="panel-log-date">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <span className={calendarClass}><i className="md-today"/> &nbsp;<span>{this.state.date ? this.state.date.format("ddd YYYY-MM-DD") : null}</span></span>
                                    </div>
                                </div>
                            </div>
                            { moment().subtract(31, 'days').isBefore(moment(this.props.logEntry.date), "DD-MM-YYYY") || this.props.pmoMode ? null :
                            <h6 style={{"text-align" : "center"}}>Please contact Tashi Support if you wish to edit this entry.</h6>
                            }
                            {
                                this.state.editTask ?
                                <div className="row">
                                    <div className="col-lg-12">
                                        <label>Task:</label>
                                        <AutoTaskInput
                                            filterByDate={this.props.pmoMode ? null : this.state.date}
                                            handleSelect={this.handleTaskChange}
                                            hideArchived={!this.props.pmoMode}
                                            hideClosed={!this.props.pmoMode}
                                            onlyTask
                                            ref="taskInput"
                                            tasks={this.state.tasks}
                                            />
                                    </div>
                                </div>
                                : null
                            }
                            <div className="row">
                                <div className="col-xs-7">
                                    <label>Duration:</label>
                                    <input disabled={!editable} type="text" onFocus={this.handleElementFocus} onBlur={this._convertToStandardForm} onChange={this.handleDurationChange} value={this.state.durationString} ref="durationInput" className="form-control"/>
                                </div>
                                <div className="col-sm-5">
                                    <div className="checkbox">
                                        <label>
                                            <input disabled={!editable} onFocus={this.handleElementFocus} onBlur={this.handleElementBlur} checked={this.state.overtime} ref="overtimeCheckbox" onChange={this.handleChange} type="checkbox"/> Overtime
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <input disabled={!editable} id="slider1" type="range" min="0" max="480" value={this.state.duration} step="30" onChange={this.handleSliderChange}/><br/>
                            <div className="row">
                                <div className={this._fieldHasError("startTime") ?  "col-xs-7 has-error" : "col-xs-7"}>
                                    <label>Start Time:</label>
                                    <input disabled={!editable} type="text" ref="startInput" onFocus={this.handleElementFocus} onBlur={this._convertStartTime} onChange={this.handleStartTimeChange} value={this.state.startTime} className="form-control"/>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <label>Description:</label>
{/*                                    <textarea disabled={!editable} onFocus={this.handleElementFocus} onBlur={this.handleElementBlur} value={this.state.description} style={{resize: 'vertical'}} maxLength="1024" onChange={this.handleDescriptionChange} ref="descriptionInput" className="form-control" rows="3"/>
*/}                                    <div className="editorModal">
                                        <SimpleHashtagEditor disabled={!editable} disableBinds={this.handleElementFocus} setupBinds={this.handleElementBlur} maxLength="1024" value={this.state.description} onChange={this.handleDescriptionChange} />
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.showCumulative ?
                                <div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <label>Logged on project:</label>
                                            <input disabled={true} type="text" className="form-control" value={DurationFormatter.format(loggedOnProject.regularTimeLogged) + " + " + DurationFormatter.format(loggedOnProject.overtimeLogged) + " overtime"}/>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <label>Logged on task:</label>
                                            <input disabled={true} type="text" className="form-control" value={DurationFormatter.format(loggedOnTask.regularTimeLogged) + " + " + DurationFormatter.format(loggedOnTask.overtimeLogged) + " overtime"}/>
                                        </div>
                                    </div>
                                </div>
                                : null
                            }
                            <div className="row">
                                <div className="col-xs-8">
                                    <label>Last Modified at:</label>
                                    <input disabled={true} defaultValue={lastModifiedAt} type="text" className="form-control"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <label>Last Modified by:</label>
                                    <input disabled={true} defaultValue={this.state.lastModifiedByUser} type="text" className="form-control"/>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {
                                editable
                                    ? <button
                                        onFocus={this.handleDeleteFocus}
                                        onBlur={this.handleDeleteBlur}
                                        type="button"
                                        onClick={this.handleSave}
                                        style={{backgroundColor : backgroundColor}}
                                        className="btn1 btn1-default btn1-primary">
                                            Update
                                      </button>
                                    : null
                            }
                            {
                                editable
                                    ? <button
                                        onFocus={this.handleDeleteFocus}
                                        onBlur={this.handleDeleteBlur}
                                        type="button" onClick={this.handleDelete}
                                        className="btn btn-default btn-discrete"
                                        data-dismiss="modal">
                                            Delete
                                      </button>
                                    : null
                            }
                            <button onFocus={this.handleCloseFocus} onBlur={this.handleRefocus} type="button" onClick={this.handleCancel} className="btn btn-default btn-discrete" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
           </Modal>
        );
    }
}

EditModal.propTypes = {
    close: PropTypes.func,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    editForUser: PropTypes.object,
    logEntry: PropTypes.object,
    logEntries: PropTypes.array,
    onRequestHide: PropTypes.func,
    parent: PropTypes.object,
    pmoMode: PropTypes.bool,
    positionLeft: PropTypes.number,
    positionTop: PropTypes.number,
    returnKeymaster: PropTypes.func,
    selectedTask: PropTypes.object,
    smartPopoverPlacement: PropTypes.bool,
    tasks: PropTypes.array,
    timesheet: PropTypes.object
};

EditModal.defaultProps = {
    smartPopoverPlacement: false,
    tasks: [],
    logEntries: []
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        selectedTask: state.tasks.selectedTask
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/EditModal.js
 **/